export default {"src":"/_next/static/media/ico_excla.d9201432.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};